import { signal } from '@angular/core';
import { RightScope } from '@shared/types';
import { Rights } from './rights';

export class MyRightsForAPoint extends Rights {
  protected scopes: RightScope | RightScope = 'points';
  protected scopesDescription =
    'Connected user rights for a point, including the point itself and allowed keys to change their values. As example, the status, in update only certain statuses can be changed.';

  private _allowedStatusesIdsToChange = signal<number[]>([]);
  public allowedStatusesIdsToChange = this._allowedStatusesIdsToChange.asReadonly();

  public setAllowedStatusesIds(statusesIds: number[]): this {
    this._allowedStatusesIdsToChange.set(statusesIds);
    return this;
  }
}
